import type { Board } from "../board";
import { PRIORITY_DEFAULT, type OnPlayerArrive } from "../interfaces";
import { MobCorpse } from "../mobs/mobCorpse";
import { Thing } from "../thing";

export class CorpseCleanerOnArrival extends Thing implements OnPlayerArrive {
	static key = "CorpseCleanerOnArrival";

	onPlayerArrive(board: Board): void {
		const corpses = board.getPhysicalThings().filter((t) => t instanceof MobCorpse);
		for (const corpse of corpses) {
			board.removeThing(corpse);
		}
	}

	getArrivePriority(): number {
		return PRIORITY_DEFAULT;
	}

	static deserialize(_data: any): CorpseCleanerOnArrival {
		return new CorpseCleanerOnArrival();
	}
}
